import { DataType } from "@/lib/types/module"
import type { ModelCategory } from "@/lib/types/module"

export type ModelParamType =
  | "enum"
  | "integer"
  | "float"
  | "boolean"
  | "string"
  | "image"
  | "video"
  | "audio"
  | "file"

export interface ModelParam {
  name: string
  label: string
  type: ModelParamType
  required?: boolean
  default?: unknown
  description?: string
  // enum
  choices?: string[]
  // numeric
  min?: number
  max?: number
  step?: number
  // string
  multiline?: boolean
}

export interface ModelParametersSchema {
  params: ModelParam[]
}

export const PARAM_TYPE_TO_DATA_TYPE: Record<ModelParamType, DataType> = {
  string: DataType.String,
  enum: DataType.String,
  integer: DataType.Number,
  float: DataType.Number,
  boolean: DataType.Boolean,
  image: DataType.Image,
  video: DataType.Video,
  audio: DataType.Audio,
  file: DataType.File,
}

export interface ModelCatalogEntry {
  id: string
  display_name: string
  provider: string
  provider_label: string
  categories: ModelCategory[]
  parameters_schema: ModelParametersSchema
  enabled: boolean
  default_for_modules: string[]
}
